import { Paddle } from '@paddle/paddle-js';
import { PaddleMap } from './types';
import { fixDiscounts } from './utils';

export let paddleInstance: Paddle, //
  paddingMapping: PaddleMap,
  discountMapping: PaddleMap,
  sendAnalytics: AnalyticsMethod,
  userEmail: string;

export const setPaddleInstance = (value: Paddle) => {
  paddleInstance = value;
};

export const setPaddleMapping = (value: PaddleMap) => {
  paddingMapping = value;
};

export const identify = (email: string) => {
  userEmail = email;

  const isEmployee = email.endsWith('@sloyd.ai');
  fixDiscounts(isEmployee);
};

export const setDiscountMapping = (value: PaddleMap) => {
  discountMapping = value;
};
